<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard class="mb-0">

                    <CCardHeader class="p-1 pt-0">
                        <CRow>
                            <CCol col="4" style="text-align: start ;">

                                <strong v-if="status_form==0">{{ $t('components.addBranch') }}</strong>
                                <strong v-else>{{ $t('buttons.editBranch') }} </strong>

                            </CCol>
                            <CCol col="4" style="text-align: center ;">

                                <strong v-if="status_form!=0">{{edit_name}}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: end">
                                <CButton
                                        class="mr-1 ml-1"
                                        v-if="status_form==0" @click="insert_data()"
                                        size="sm"
                                        color="secondary"
                                >{{ $t("buttons.submit") }}
                                </CButton>
                                <CButton
                                        class="mr-1"
                                        v-if="status_form!=0" @click="insert_data()"
                                        size="sm"
                                        color="secondary"
                                >{{ $t("buttons.edit") }}
                                </CButton>
                                <CButton
                                        class="mr-1"
                                        v-if="status_form!=0" @click="emptyList()"
                                        size="sm"
                                        color="secondary"
                                >{{ $t("buttons.cancel") }}
                                </CButton>
                                <CButton
                                        class="mr-1"
                                        size="sm"
                                        color="secondary"
                                >{{ $t("buttons.print") }}
                                </CButton>

                            </CCol>
                        </CRow>
                    </CCardHeader>

                    <CCardBody>

                        <CRow>
                            <CCol col="4">
                                <CInput
                                        :label="$t('components.branchName')"
                                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                        v-model="name"
                                        autocomplete="name"

                                />
                                <CRow form class="form-group">
                                    <CCol tag="label" sm="5" class="col-form-label">
                                        {{$t('components.branchOwner')}}
                                    </CCol>
                                    <CCol sm="7">
                                        <treeselect
                                                v-model="document_person"

                                                :async="person_async"
                                                :options="person_list"
                                                :load-options="load_persons"
                                                :placeholder="$t('components.branchOwner')"
                                                :normalizer="normalizer_persons"
                                        />
                                    </CCol>
                                </CRow>
                                <CRow form class="form-group">
                                    <CCol tag="label" sm="5" class="col-form-label">
                                        {{ $t('RegisteredDate') }}
                                    </CCol>
                                    <CCol sm="7">
                                        <date-picker
                                                v-model="main_address.registeredDate"
                                                format="YYYY-MM-DD"
                                        ></date-picker>
                                    </CCol>
                                </CRow>
                                <CInput
                                        :label="$t('VATNumber')"
                                        :value.sync="main_address.vatNumber"

                                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                />
                                <CRow form class="form-group">
                                    <CCol tag="label" sm="5" class="col-form-label">
                                        {{ $t('VATDate') }}
                                    </CCol>
                                    <CCol sm="7">
                                        <date-picker
                                                v-model="main_address.vatDate"

                                        ></date-picker>
                                    </CCol>
                                </CRow>
                                <CRow form class="form-group">
                                    <CCol tag="label" sm="5" class="col-form-label">
                                        {{ $t('Logo') }}
                                    </CCol>
                                    <CCol sm="7">
                                        <CInputFile
                                                :label="$t('components.image')"
                                                custom
                                                horizontal
                                                ref="file_selector"
                                                v-show="false"
                                                v-on:change="handleFileUpload"
                                        />
                                        <div class="text-center" v-on:click="open_file_selector()"
                                        >
                                            <CImg height="100px"
                                                  width="100%"
                                                  v-model="previewImage"
                                                  v-if="previewImage" :src="previewImage"
                                            />
                                        </div>

                                    </CCol>
                                </CRow>


                            </CCol>
                            <CCol col="4">
                                <div v-if="date_time_locale=='fa'">

                                    <CSelect
                                            :label="$t('components.province')"
                                            :value.sync="selected_province"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                            :options="province_items"
                                    />
                                    <CSelect
                                            :label="$t('components.city')"
                                            :value.sync="selected_city"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                            :options="city_items"
                                    />

                                    <CSelect
                                            :label="$t('newTown')"
                                            :value.sync="selected_district"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                            :options="district_items"
                                    />
                                    <CSelect
                                            :label="$t('newArea')"
                                            :value.sync="selected_area"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                            :options="area_items"
                                    >
                                        <template #append-content>
                                            <CIcon size="sm" v-on:click.native="go_to_add_modal('add_area')"
                                                   name="cil-plus"/>
                                        </template>
                                    </CSelect>

                                    <CInput
                                            :label="$t('address')"
                                            :value.sync="main_address.Street"
                                            :placeholder="$t('languageAddress')"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                    />

                                    <CInput
                                            :label="$t('PostCode')"
                                            :value.sync="main_address.PostCode"
                                            @keypress="isPostCode"
                                            placeholder="A-Z 0-9"

                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                    >
                                        <template #append-content>
                                            <CIcon v-on:click.native="mapModal = true" class="text-white"
                                                   name="cil-location-pin"/>

                                        </template>
                                    </CInput>
                                    <CSelect
                                            :label="$t('Country')"
                                            :value.sync="selected_country"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                            :options="country_items"
                                    />
                                </div>
                                <div v-if="date_time_locale=='en'">

                                    <CInput
                                            :label="$t('address')"
                                            :placeholder="$t('languageAddress')"
                                            :value.sync="main_address.Street"

                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                    />


                                    <CSelect
                                            :label="$t('components.province')"
                                            :value.sync="selected_province"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                            :options="province_items"
                                    />
                                    <CSelect
                                            :label="$t('components.city')"
                                            :value.sync="selected_city"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                            :options="city_items"
                                    />

                                    <CSelect
                                            :label="$t('newTown')"
                                            :value.sync="selected_district"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                            :options="district_items"
                                    />
                                    <CSelect
                                            :label="$t('newArea')"
                                            :value.sync="selected_area"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                            :options="area_items"
                                    >
                                        <template #append-content>
                                            <CIcon size="sm" v-on:click.native="go_to_add_modal('add_area')"
                                                   name="cil-plus"/>
                                        </template>
                                    </CSelect>

                                    <CInput
                                            :label="$t('PostCode')"
                                            :value.sync="main_address.PostCode"
                                            placeholder="A-Z 0-9"
                                            @keypress="isPostCode"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                    >
                                        <template #append-content>
                                            <CIcon v-on:click.native="mapModal = true" class="text-white"
                                                   name="cil-location-pin"/>

                                        </template>
                                    </CInput>
                                    <CSelect
                                            :label="$t('Country')"
                                            :value.sync="selected_country"
                                            :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                            :options="country_items"
                                    />
                                </div>

                            </CCol>
                            <CCol col="4">

                                <CCard>
                                    <CCardHeader>
                                        <CRow>
                                            <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                                <strong>{{ $t('Contacts') }}</strong>
                                            </CCol>
                                            <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                                            </CCol>
                                        </CRow>
                                    </CCardHeader>
                                    <CCardBody style="max-height: 100px;overflow: auto">

                                        <div v-for="phone_obj in phone_objects" :key="phone_obj.row_id">
                                            <CInput
                                                    class="m-0"
                                                    maxlength="11"
                                                    :placeholder="$t('components.number')"
                                                    :value.sync="phone_obj.phone"
                                            >
                                                <template #prepend-content>
                                                    <CIcon v-on:click.native="remove_phone_obj(phone_obj.row_id)"
                                                           name="cil-minus"/>
                                                </template>
                                                <template #append-content>
                                                    <CIcon v-on:click.native="add_phone_obj()" name="cil-plus"/>
                                                </template>
                                            </CInput>

                                        </div>
                                    </CCardBody>
                                </CCard>
                                <CCard>
                                    <CCardHeader>
                                        <CRow>
                                            <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                                <strong>{{ $t('Emails') }}</strong>
                                            </CCol>
                                            <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                                            </CCol>
                                        </CRow>
                                    </CCardHeader>
                                    <CCardBody style="max-height: 100px;overflow: auto">

                                        <div v-for="phone_obj in email_objects" :key="phone_obj.row_id">
                                            <CInput
                                                    class="m-0"
                                                    :placeholder="$t('EmailAddress')"
                                                    :value.sync="phone_obj.phone"
                                            >
                                                <template #prepend-content>
                                                    <CIcon v-on:click.native="remove_email_obj(phone_obj.row_id)"
                                                           name="cil-minus"/>

                                                </template>
                                                <template #append-content>
                                                    <CIcon v-on:click.native="add_email_obj()" name="cil-plus"/>

                                                </template>
                                            </CInput>

                                        </div>
                                    </CCardBody>
                                </CCard>
                                <CCard>
                                    <CCardHeader>
                                        <CRow>
                                            <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                                                <strong>{{ $t('Websites') }}</strong>
                                            </CCol>
                                            <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">
                                            </CCol>
                                        </CRow>
                                    </CCardHeader>
                                    <CCardBody style="max-height: 100px;overflow: auto">

                                        <div v-for="phone_obj in website_objects" :key="phone_obj.row_id">
                                            <CInput
                                                    class="m-0"
                                                    :placeholder="$t('WebsiteAddress')"
                                                    :value.sync="phone_obj.phone"
                                            >
                                                <template #prepend-content>
                                                    <CIcon v-on:click.native="remove_website_obj(phone_obj.row_id)"
                                                           name="cil-minus"/>

                                                </template>
                                                <template #append-content>
                                                    <CIcon v-on:click.native="add_website_obj()" name="cil-plus"/>

                                                </template>
                                            </CInput>

                                        </div>
                                    </CCardBody>
                                </CCard>


                            </CCol>
                        </CRow>

                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>

        <CRow class="mt-0">
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{ $t('components.branches') }}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable
                                :items="items"
                                :fields="fields"
                                @row-clicked="table_row_clicked"
                                style="height:120px;overflow:auto"
                                :items-per-page="20"
                                hover
                                sorter
                                pagination
                        >
                            <template #row="{item}">

                                <td style="text-align: center">
                                    <p >{{ item.row_id + 1 }}</p>

                                </td>

                            </template>
                            <template #branchTitle="{item}">

                                <td>
                                    <p >{{ item.branchTitle }}</p>

                                </td>

                            </template>

                            <template #provinceTitle="{item}">

                                <td>
                                    <p >{{ item.provinceTitle }}</p>

                                </td>

                            </template>

                            <template #cityTitle="{item}">

                                <td>
                                    <p >{{ item.cityTitle }}</p>

                                </td>

                            </template>


                            <template #operation="{item,index}">
                                <td>
                                    <!--                  <CButton class="mr-1"-->
                                    <!---->
                                    <!--                           variant="outline"-->
                                    <!--                           square-->
                                    <!--                           size="sm"-->
                                    <!--                           :title="$t('buttons.edit')"-->
                                    <!--                           @click="edit_item(item)"-->
                                    <!--                  >-->
                                    <!--                    <CIcon size="sm" class="text-primary" name="cil-pencil"/>-->
                                    <!--                  </CButton>-->
                                    <CButton class="mr-1 p-0"
                                             square
                                             size="sm"

                                             :title="$t('organizationChart')"
                                             @click="goChart(item)"
                                    >
                                        <CIcon class="text-success"

                                               size="sm" name="cil-people"/>
                                    </CButton>
                                    <!--                  <CButton class="mr-1"-->
                                    <!--                           color="danger"-->
                                    <!--                           variant="outline"-->
                                    <!--                           square-->
                                    <!--                           :title="$t('buttons.delete')"-->
                                    <!--                           size="sm"-->
                                    <!--                           @click="delete_item_dialog(item)"-->
                                    <!--                  >-->
                                    <!--                    <CIcon name="cilTrash"/>-->
                                    <!--                  </CButton>-->

                                    <CButton class="mr-1"
                                             square
                                             :title="$t('buttons.delete')"
                                             size="sm"
                                             @click="delete_item_dialog(item)"
                                    >
                                        <CIcon name="cilTrash" size="sm" class="text-danger"/>
                                    </CButton>
                                </td>
                            </template>


                        </CDataTable>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
                :show.sync="mapModal"
                :no-close-on-backdrop="true"
                color="transparent"
                border-color="primary"
                :title="$t('components.map')"
        >

            <div :style="{ height: '250px'}" id='map'></div>

            <template #footer>
                <CButton
                        @click="mapModal = false"
                        color="danger"
                >{{ $t("buttons.close") }}
                </CButton>
            </template>
        </CModal>
        <CModal
                :show.sync="branch_position_dialog"
                :no-close-on-backdrop="true"
                color="transparent"
                border-color="primary"
                :title="$t('components.map')"
        >
            <BranchPositionsNew :branch_id="selected_branch_id"/>

            <template #footer>
                <CButton
                        @click="branch_position_dialog = false"
                        color="danger"
                >{{ $t("buttons.close") }}
                </CButton>
            </template>
        </CModal>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import mapboxgl from 'mapbox-gl'
    import BranchPositionsNew from "./BranchPositionsNew";

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }

    var items = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,
            BranchPositionsNew
        },
        data() {
            return {
                edit_name: '',
                confirm_delete_name: "confirm_branch" + new Date().getTime() + "_" + this.$vnode.tag,
                fields: [
                    {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
                    {key: 'branchTitle', label: this.$t('tables.name'), _style: 'width:10%'},
                    {key: 'province', label: this.$t('tables.province'), _style: 'width:10%'},
                    {key: 'city', label: this.$t('tables.city'), _style: 'width:10%;'},
                    {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
                ],
                date_time_locale: this.$i18n.locale,
                mapModal: false,
                marker: null,
                map: null,
                show_map_check: false,
                user_location_lat: 0,
                user_location_lng: 0,
                selected_branch_id: 0,
                phone_objects: [{phone_type: 19, phone: '', row_id: 1}],
                email_objects: [{phone_type: 19, phone: '', row_id: 1}],
                website_objects: [{phone_type: 19, phone: '', row_id: 1}],
                person_async: true,
                branch_position_dialog: false,
                person_list: [],
                validate_errors: [],
                name: '',
                file: '',
                color: '#ffffff',
                previewImage: '/img/placeholder.png',
                show_add: false,
                branch_address: '',
                description: '',
                items: items.map((item, row_id) => {
                    return {...item, row_id}
                }),

                area_items: [],
                selected_area: 0,

                district_items: [],
                selected_district: 0,

                province_items: [],
                selected_province: 0,

                city_items: [],
                selected_city: 0,

                country_items: [],
                selected_country: 0,

                main_address: {registeredDate: '', vATDate: '',},

                table_clicks_timer: null,
                table_clicks: 0,

                details: [],
                collapseDuration: 0,
                status_form: 0,
                document_person: null,
                load_persons({action, searchQuery, callback}) {
                    // var self = this;

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            formData.append('IsVendor', false);
                            formData.append('IsWorker', true);
                            formData.append('IsCustomer', false);
                            formData.append('IsActive', 0);

                            axios.post('GetAllPersons', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {
                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.fullName,
                    }
                },
            }
        },
        created() {
        },
        mounted() {
            this.$root.root_validate_errors = [];

            this.createMap();

            this.get_lists();
            // this.get_provinces();
            this.get_country()
            bus.$on('close_add_base_modal', (data) => {
                this.get_areas();
            });
            bus.$on('change_branch_position_dialog', (data) => {
                this.branch_position_dialog = data
            });

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });

        }, watch: {
            '$route.params.cat_id': function () {
                this.get_lists();
            },
            'selected_province': function () {
                console.log("peovince changed");
                this.get_cities();
            },
            'selected_city': function () {
                this.get_districts();
            },
            'selected_district': function () {
                this.get_areas();
            },
            'selected_country': function () {
                this.get_provinces();
            },
        },
        methods: {
            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    this.edit_item(item)
                    this.table_clicks = 0

                }
            },
            createMap() {
                var self = this;
                // init the map
                mapboxgl.accessToken = 'pk.eyJ1Ijoib21kZXNobyIsImEiOiJjanoyaW1zNG4wMHI1M2JteTQyZXhqaTI3In0.M0GJxZnal_ysW7mxXWEZLg';
              if(mapboxgl.getRTLTextPluginStatus()=="unavailable") {
                        mapboxgl.setRTLTextPlugin(
                            'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
                            null,
                            true // Lazy load the plugin
                        );
                    }

                var center_loc = [51.37734351262877, 35.697451890638886];
                if (self.$i18n.locale == 'en') {
                    center_loc = [-0.03880407284764019, 51.573360744046745];
                }
                self.map = new mapboxgl.Map({
                    container: 'map',
                    style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
                    center: center_loc,
                    zoom: 14 // starting zoom
                });

                self.polygon_draw = new MapboxDraw({
                    displayControlsDefault: false,
                    controls: {
                        polygon: true,
                        trash: true
                    }
                });
                // self.map.addControl(self.polygon_draw);
                // self.map.on('draw.create', self.updatePolygonArea);
                // self.map.on('draw.delete', self.updatePolygonArea);
                // self.map.on('draw.update', self.updatePolygonArea);

                // self.map.addControl(new mapboxgl.Navigation())
                self.map.on('click', function (e) {
                    if (self.marker != null) {
                        self.marker.remove();
                    }
                    // if (self.user_location_lat == 0) {

                    self.marker = new mapboxgl.Marker({
                        draggable: true
                    })

                        .setLngLat(e.lngLat)
                        .addTo(self.map);
                    self.user_location_lat = e.lngLat.lat;
                    self.user_location_lng = e.lngLat.lng;

                    // }

                    function onDragEnd() {
                        // var lngLat = marker.getLngLat();
                        self.user_location_lat = self.marker.getLngLat().lat;
                        self.user_location_lng = self.marker.getLngLat().lng;

                    }

                    function onDragStart() {
                        // var lngLat = marker.getLngLat();
                        console.log("drag started");
                        self.user_location_lat = self.marker.getLngLat().lat;
                        self.user_location_lng = self.marker.getLngLat().lng;

                    }

                    self.marker.on('dragend', onDragEnd);
                    self.marker.on('dragstart', onDragStart);
                    console.log('A click event has occurred at ' + e.lngLat);
                    // }

                });

                self.map.on('load', function () {
                    // self.show_polygon();
                });
            },
            go_to_add_modal(func) {
                bus.$emit("show_add_base_modal", func);
            },
            add_phone_obj() {
                console.log('add clicked')

                this.phone_objects.push({row_id: 19, phone_type: 0, phone: ''})
                var copy = this.phone_objects;
                this.phone_objects = [];
                this.phone_objects = copy;

            },
            remove_phone_obj(index) {
                console.log('remove clicked')
                if (this.phone_objects.length > 1) {
                    this.phone_objects.splice(index - 1, 1);
                    var row_index = 1;
                    this.phone_objects.forEach((val) => {
                        val.row_id = row_index;
                        row_index += 1;

                    });

                    var copy = this.phone_objects;
                    this.phone_objects = [];
                    this.phone_objects = copy;

                }
            },
            add_email_obj() {
                console.log('add clicked')

                this.email_objects.push({row_id: 19, phone_type: 0, phone: ''})
                var row_index = 1;
                this.email_objects.forEach((val) => {
                    val.row_id = row_index;
                    row_index += 1;

                });


                var copy = this.email_objects;
                this.email_objects = [];
                this.email_objects = copy;

            },
            remove_email_obj(index) {
                console.log('remove clicked')
                if (this.email_objects.length > 1) {
                    this.email_objects.splice(index - 1, 1);
                    var row_index = 1;
                    this.email_objects.forEach((val) => {
                        val.row_id = row_index;
                        row_index += 1;

                    });

                    var copy = this.email_objects;
                    this.email_objects = [];
                    this.email_objects = copy;

                }
            },
            add_website_obj() {
                console.log('add clicked')

                this.website_objects.push({row_id: 19, phone_type: 0, phone: ''})
                var row_index = 1;
                this.website_objects.forEach((val) => {
                    val.row_id = row_index;
                    row_index += 1;

                });


                var copy = this.website_objects;
                this.website_objects = [];
                this.website_objects = copy;

            },
            remove_website_obj(index) {
                console.log('remove clicked')
                if (this.website_objects.length > 1) {
                    this.website_objects.splice(index - 1, 1);
                    var row_index = 1;
                    this.website_objects.forEach((val) => {
                        val.row_id = row_index;
                        row_index += 1;

                    });

                    var copy = this.website_objects;
                    this.website_objects = [];
                    this.website_objects = copy;

                }
            },
            open_file_selector() {
                this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
            },
            get_image_file(item) {
                // console.log("image url is " + item.imageName);
                return this.$root.base_url + item.imageName;
            },
            handleFileUpload(files, e) {
                this.file = e.target.files[0];
                this.previewImage = URL.createObjectURL(this.file);
            },
            validateForm: function () {
                this.$root.root_validate_errors = [];

                if (this.name != '' && this.selected_province != 0 && this.document_person != null) {
                    return true;
                }


                if (this.name == '') {
                    this.$root.root_validate_errors.push(this.$t('insertName'));
                }
                if (this.selected_province == 0) {
                    this.$root.root_validate_errors.push(this.$t('insertProvince'));
                }
                if (this.selected_city == 0) {
                    this.$root.root_validate_errors.push(this.$t('insertCity'));
                }

                if (this.branch_address == 0) {
                    this.$root.root_validate_errors.push(this.$t('insertAddress'));
                }
                if (this.document_person == 0) {
                    this.$root.root_validate_errors.push(this.$t('selectUser'));
                }
                return false;
                // e.preventDefault();
            },

            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = item.branchTitle;
                this.edit_name = item.branchTitle;
                this.document_person = item.ownerId
                this.person_async = false;
                this.person_list = [{userId: item.ownerId, fullName: item.ownerName}]
                this.main_address.registeredDate = item.registeredDate
                this.main_address.vatNumber = item.vatNumber
                this.main_address.vatDate = item.vatDate
                this.previewImage = item.logo
                this.selected_country = item.countryId
                this.selected_province = item.provinceId
                this.selected_city = item.cityId
                this.selected_district = item.regionId
                this.selected_area = item.areaId
                this.main_address.Street = item.street
                this.main_address.HouseNO = item.houseNO
                this.main_address.PostCode = item.postCode
                var contacts = item.branchContacts;
                if (this.previewImage == null) {
                    this.previewImage = '/img/placeholder.png';
                }
                this.phone_objects = [];
                this.email_objects = [];
                this.website_objects = [];
                contacts.forEach(val => {
                    if (val.contactType == 1) {
                        this.phone_objects.push({
                            phone_type: 19,
                            phone: val.contactText,
                            row_id: this.phone_objects.length + 1
                        })
                    }
                    if (val.contactType == 2) {
                        this.email_objects.push({
                            phone_type: 19,
                            phone: val.contactText,
                            row_id: this.email_objects.length + 1
                        })
                    }
                    if (val.contactType == 3) {
                        this.website_objects.push({
                            phone_type: 19,
                            phone: val.contactText,
                            row_id: this.website_objects.length + 1
                        })
                    }
                });
                if (this.phone_objects.length == 0) {
                    this.phone_objects.push({phone_type: 19, phone: "", row_id: 1})
                }
                if (this.email_objects.length == 0) {
                    this.email_objects.push({phone_type: 19, phone: "", row_id: 1})
                }
                if (this.website_objects.length == 0) {
                    this.website_objects.push({phone_type: 19, phone: "", row_id: 1})
                }
                // this.selected_province = this.items[item.row_id].provinceId;
                // this.selected_city = this.items[item.row_id].cityId;
                // this.get_cities();
                // this.polygon_area = JSON.parse(this.items[item.row_id].areaRange);
                // this.show_polygon();

                this.status_form = item.branchId;
                setTimeout(() => {
                    this.person_async = true

                }, 500);
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            emptyList() {
               var self = this;
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                self.status_form = 0;
                // self.name = '';
                // self.color = '';
                // self.description = '';
                self.file = null
                self.main_address = {registeredDate: '', vATDate: '',}
                self.selected_country = 0
                self.selected_province = 0
                self.selected_city = 0
                self.selected_area = 0
                self.selected_district = 0
                self.name = ''
                self.branch_address = ''
                self.document_person = null
                self.previewImage = '/img/placeholder.png';
                self.phone_objects= [{phone_type: 19, phone: '', row_id: 1}]
                    self.email_objects= [{phone_type: 19, phone: '', row_id: 1}];
                    self.website_objects= [{phone_type: 19, phone: '', row_id: 1}]
                self.get_lists();
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_lists() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_province);


                axios.post('GetBranchList', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goSubCategories(item) {

                this.$router.push({path: '/users/list-users/' + item.id});
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            goChart(item) {
                this.selected_branch_id = item.branchId;
                this.branch_position_dialog = true;
                // this.$router.push({path: '/dashboard/base/branch-position/' + item.branchId});
            },
            get_provinces() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_country);


                axios.post('GetStateList', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.province_items = [];

                        self.province_items = self.sort_array(
                            self.province_items, content_data.data,
                            'id', 'provinceName');


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_country() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetCountries', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.country_items = [];
                        self.country_items = self.sort_array(
                            self.country_items, content_data.data,
                            'id', 'title');

                        if (self.$i18n.locale == 'fa') {
                            self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
                        }
                        if (self.$i18n.locale == 'en') {
                            self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
                        }

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            get_cities() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_province);

                axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.city_items = []
                        self.city_items = self.sort_array(
                            self.city_items, content_data.data,
                            'cityId', 'cityName');


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            insert_data() {

                if (!this.validateForm()) {
                    console.log("validate form is false" + this.validate_errors);
                    return true;
                }
                let self = this;
                var sended_obj = {}
                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "AddBranch";
                } else {
                    url = "EditBranch";
                    sended_obj.BranchId = this.status_form

                }

                // public ICollection<BranchContact> BranchContacts { get; set; }

                sended_obj.PostCode = this.main_address.PostCode;
                sended_obj.Street = this.main_address.Street;
                sended_obj.HouseNO = this.main_address.HouseNO;
                formData.append('Logo', this.file);
                sended_obj.VatDate = this.main_address.vatDate;
                sended_obj.VATNumber = this.main_address.vatNumber;
                sended_obj.RegisteredDate = this.main_address.registeredDate;
                sended_obj.CountryId = this.selected_country;
                sended_obj.ProvinceId = this.selected_province;
                sended_obj.CityId = this.selected_city;
                sended_obj.AreaId = this.selected_area;
                sended_obj.RegionId = this.selected_district;
                sended_obj.BranchTitle = this.name;
                sended_obj.AddressText = this.branch_address;
                sended_obj.OwnerId = this.document_person;
                var phones = [];

                for (var i = 0; i < this.phone_objects.length; i++) {
                    // phones.push(this.phone_objects[i].phone)
                    phones.push({ContactType: 1, ContactText: this.phone_objects[i].phone})

                }

                for (i = 0; i < this.email_objects.length; i++) {
                    phones.push({ContactType: 2, ContactText: this.email_objects[i].phone})

                }

                for (i = 0; i < this.website_objects.length; i++) {
                    phones.push({ContactType: 3, ContactText: this.website_objects[i].phone})
                }

                sended_obj.BranchContacts = phones;
                formData.append('model', JSON.stringify(sended_obj));

                axios.post(url, formData, {}).then((res) => {

                    if (res.data.statusCode == 0) {
                        self.status_form = 0;
                        // self.name = '';
                        // self.color = '';
                        // self.description = '';
                        self.file = null
                        self.main_address = {registeredDate: '', vATDate: '',}
                        self.selected_country = 0
                        self.selected_province = 0
                        self.selected_city = 0
                        self.selected_area = 0
                        self.selected_district = 0
                        self.name = ''
                        self.branch_address = ''
                        self.document_person = null
                        self.previewImage = '/img/placeholder.png';

                        self.get_lists();
                    }


                    self.$root.modal_component.show_api_response_modals(res);

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            }, delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);
                this.status_form = item.branchId;

            }, delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeleteBranch";


                formData.append('BranchId', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            get_areas() {
                var self = this;
                const formData = new FormData();

                formData.append('id', this.selected_district);

                axios.post('GetAreaTitlesByCityId', formData, {show_pros: true}).then(function (response) {
                    self.area_items = [];
                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        var obj = {label: self.$t('dialogs.insertArea'), value: 0}
                        self.area_items.push(obj);
                        self.area_items = self.sort_array(
                            self.area_items, content_data.data,
                            'id', 'areaName');

                        // content_data.data.forEach((val) => {
                        //   var obj = {label: val.areaName, value: val.id}
                        //
                        //   self.area_items.push(obj);
                        // });


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_districts() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_city);

                axios.post('GetRegionByCityId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.district_items = []
                        self.district_items = self.sort_array(
                            self.district_items, content_data.data,
                            'id', 'title');

                        if (self.$route.params.user_id == null) {
                            self.selected_district = self.district_items[0].value;
                        }

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

        }
    }

</script>
